'use strict'

class ApiInterceptorService {
  constructor ($log, $window, Localization, $httpParamSerializerJQLike, $rootScope, $q, BufferFactory) {
    this.$log = $log
    this.$window = $window
    this.Localization = Localization
    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike
    this.$rootScope = $rootScope
    this.$q = $q
    this.BufferFactory = BufferFactory
    this.endpoint = Localization.getLocalizedAppConfig().endpoint
    this.request = this.request.bind(this)
    this.response = this.response.bind(this)
    this.responseError = this.responseError.bind(this)
  }

  static factory ($log, $window, Localization, $httpParamSerializerJQLike, $rootScope, $q, BufferFactory) {
    'ngInject'
    return new ApiInterceptorService($log, $window, Localization, $httpParamSerializerJQLike, $rootScope, $q, BufferFactory)
  }

  request (req) {
    if (req.url.startsWith(this.endpoint)) {
      req.withCredentials = true
      req.headers = Object.assign({
        'X-Country': this.Localization.getCountry()
      }, req.headers)
      if (req.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
        req.data = this.$httpParamSerializerJQLike(req.data)
      }
      if (this.$window.sessionStorage['token']) {
        const tokens = JSON.parse(this.$window.sessionStorage['token'])
        req.headers['Authorization'] = `Bearer ${tokens.access_token}`
      }
      if (this.$window.sessionStorage['user']) {
        const user = JSON.parse(this.$window.sessionStorage['user'])
        const customer = user.customer
        const email = customer.email
        req.headers['X-Email'] = email
      }
      if (this.$window.sessionStorage['vin']) {
        const vin = this.$window.sessionStorage['vin']
        req.headers['X-Vin'] = vin
      }
      this.$log.debug('API REQUEST', req)
    }
    return req
  }

  response (res) {
    if (res.config.url.startsWith(this.endpoint)) {
      this.$log.debug('API BUSINESS RESPONSE', res)
      // Save token into the sessionStorage
      if (res.data.token) {
        this.$window.sessionStorage['token'] = JSON.stringify(res.data.token)
      }
    }
    return Promise.resolve(res)
  }

  responseError (rejection) {
    if (rejection.config.url.startsWith(this.endpoint)) {
      this.$log.error('API ERROR: [', rejection.status, '] - ', rejection.message)
      const logoutUrl = this.endpoint + '/logout'
      const refreshTokenUrl = this.endpoint + '/refresh'
      if (rejection.status === 502 && rejection.data && rejection.data.meta && rejection.data.meta.code === 'ECONNREFUSED') {
        this.$log.error('API ERROR ECONNREFUSED: R-LINK Store not started')
        this.$rootScope.$broadcast('service:stopped')
      }
      if (rejection.status === 503) {
        this.$log.error('API IN MAINTENANCE')
        this.$rootScope.$broadcast('service:maintenance')
      }
      if ((rejection.status === 401 || (rejection.data && rejection.data.meta && rejection.data.meta.statusCode === 401)) &&
          !rejection.config.url.match(new RegExp(logoutUrl)) &&
          !rejection.config.url.match(new RegExp(refreshTokenUrl))) {
        // Try to obtain a new access_token with the refresh_token
        const config = rejection.config || {}
        const deferred = this.$q.defer()
        const bufferLength = this.BufferFactory.append(config, deferred)
        this.$log.debug('Buffer length: ', bufferLength)
        if (bufferLength === 1) {
          this.$log.error('API ERROR 401: broadcasting user:unauthorized to try and get and new access token')
          this.$rootScope.$broadcast('user:unauthorized', rejection)
        }
        return deferred.promise
      }
      return Promise.reject(rejection)
    }
    return Promise.reject(rejection)
  }
}

export default ApiInterceptorService



// WEBPACK FOOTER //
// ./src/app/common/interceptors/api-interceptor.factory.js